import React, { useEffect, useState, useRef } from 'react';
import { LandingHeader } from './LandingHeader';
import { SimpleFooter } from '../footer/Footer';
import { useAuthToken } from '../../hooks/useAuthToken';
import { useUserPlan } from '../../hooks/useUserPlan';
import { PLAN_TYPE_EAN_STUDENT_TACHER_COLLABORATOR } from '../../assets/constants';
import { AcceptDialog } from '../controls/UIControls';
import WebChatZoomCrm from '../../assets/zoom-messenger-react/lib/addBubble.js';

export const LandingPage = () => {
  const [eanuserDialog, setEanuserDialog] = useState(false);
  const { authToken, isLogged } = useAuthToken();
  const { checkUserPlan } = useUserPlan();
  const setEanActivePlan = useState(false);
  const [iframeHeight, setIframeHeight] = useState('200');
  const iframeRef = useRef(null);
  const ajustarAlturaIframe = () => {
    if (iframeRef.current) {
      const iframeWidth = iframeRef.current.offsetWidth;
      const aspectRatio = 9 / 16;
      const newHeight = Math.floor(iframeWidth * aspectRatio);
      setIframeHeight(`${newHeight}px`);
    }
  };
  useEffect(() => {
    ajustarAlturaIframe();
    const handleResize = () => {
      ajustarAlturaIframe();
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (isLogged()) {
      checkUserPlan(authToken).then((hasPlan) => {
        if (hasPlan && hasPlan.planType == PLAN_TYPE_EAN_STUDENT_TACHER_COLLABORATOR) {
          setEanActivePlan(true);
        }
      });
    }
  }, []);

  window.addEventListener('scroll', function () {
    if (this.window.scrollY > 100) {
      const elements = this.document.getElementsByClassName('landing__whatsapp-button-static');
      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        element.classList.add('landing__whatsapp-button');
        element.classList.remove('landing__whatsapp-button-static');
      }
    }
  });
  return (
    <>
      <LandingHeader />
      <div id="contWebChatZoomCrm">
        <WebChatZoomCrm
          elementId="contWebChatZoomCrm"
          backgroundColor="#3BAC53"
          color="#FFFFFF"
          socialGatewayUrl="https://socialgateway.verzia.io/modules/zoomWebChat/zoomMessengerLog.php?params=N3hMWEdVWndFVytYQnE4cU4xSm1pMlhRaHVvSXVPRmVuNjQrdGFvS0o4cTZaOSt2eFEyNmhoM1Y3TDk1MWNXZFhUbld3YXlEOUdEUlliTUVvYkFkVGEvMHJlNS9pQVFyTXc1MTVOZGNPRW9LN0VsZFNwdFllRFBCVzhrYm1HZ1YyeXFDVE9TUlZYdTBuUE9TbnVaTHM2RkNJVGErSGNDTTFvek5EeXNuc3dhOTJ6RG1TcXdGSmV2eFMwbEJZSmtuUzA0M2cxQ2c5cEpwV1Y2Z1pGZ3lmZ3JHeVp0cFdxTk5UaWZVSStQMmZYR2gxWXVwV2tUWithQzFxTnIwSzFTZmdtenNva0U5NHlaM3pxY3RJVkFQUnl6d1N4MHJONFplem1EN3o5dGc3VUkrR0U3Z05BekE0V2NKNW9NRjl3dldVMUYyUnRYV05yeFk0Q2dDR1VtTDdRd1FtL1BkVUp5U01obktRN2lSeThuWWJaZmtMTkUrcjgyVFFJMFFCM1NKM1p4ckNOUW5sTy9LYWFWbWhqYTJYQWtXTEVjbXoyNDRFd2s1OXNsTlI2R0VuNmVNdHhEbE1hQVdRTER0Wk5rcnVkU0g3Wk9TNmc3QkJRUlRkTnJDbHA2ZXpvVW5SbkFjMlFFK2xLUmhVUHRPQU83S0xmOWd6elkvZ01XeTdqM1BoaDIwQzFEMk12N2pUZitJNFMwYkdFcWUweHJyeFlNSUwxWkhMUXFxMlpCRUpUZFY3dGpsazdBcEtoRS9OdjlrdnphUDcrTnNWQ0xXQWJRWjBMTXlBQmJuekxleFZDbzBWcDkyUzU2dks5b0NxT3l0Vk4xRk5Majlldytqcy9hbk1nSndTVVBRRXlZQlVuMitsYkNpVGtTaVhRdElaa0VyVDMvc3pNSjRvUUdnUlpOdVV5NWpsOUJJSjhnY0hQbC80Z2s5YjE3akZraHVwZ0EzZitFdFIzSEloTERJM0ozSUlua3RZMTNQdm02ZERVM0ZUdjBsaUVLTjk0SGxEN2Y2KzRjWDNXS2tqakVlWGhlRmdxY1Z0WnNWSVhJVjdTclljV09QaUFQbWxsSE1xWldoUzdlN3BGSWtqb0dJV0l5cmFnNnFqNEtWc3VuRnhmNmhsY1FTa1NINGZNYlJBYkdSU2pZZlpKM3d4S1R3MUZrQkpRbVJyVG00SWFYS1RvVzNmOWNTbHF4WWNXWGRZVmV0QXZ5M3V6d1B5TkdpbXhORXJjTUdoWDRQWmo1Z1RxcWxGTzFNNWt4RWZQakh3QzNNcm9GU0hXcGNldDkwR01CbGhmMHlXQ09pck1oT3o4S1NrVkw1U1dNQUY0aURuampZMHBrdldBN0xHUlNmeSt1M0hNbm1iNXV4REh4bWJ3R1VSWFZFaXhnR0ZwQVV5MWhadFZTV1htelFZYjdzR3Y4VE5OY2svQjNMZjdHY0h0MGFCR2lSdEF1TkhmQ2lSZFBDV2VMczQ3ZXU1N1FzZzA5RmxDd21JV3R1WkE1WWJIclFCamJNKytuNVhNeE1TempUTXEzY1lYY0QxSzBmQ01GZnp5bHhna0lrYVB3Y1BVTW11TU45TUxRLzczYz0="
        />
      </div>
      <AcceptDialog
        open={eanuserDialog}
        message="Ya disfrutas de un plan B2B."
        style="info"
        afterClose={() => setEanuserDialog(false)}
      ></AcceptDialog>
      <div className="landing__container-eres-comunidad-eanista mt-5">
        <div className="container my-5">
          <div className="row justify-content-center align-items-center">
            <div
              className="col-12 d-block d-lg-none"
              style={{ overflow: 'hidden', textAlign: 'center', margin: '0 auto' }}
            >
              <iframe
                className="col-12"
                width="560"
                height="315"
                src="https://www.youtube.com/embed/4McWM-mF1w8?si=ReyazLDww5QSFHW9&amp;controls=0"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
            <div className="col-xl-5 col-12">
              <div className="row">
                <div className="col-12 landing__text-eres-comunidad-eanista">
                  <span className="landing__text-color-green">
                    ¡Vive la experiencia de Usuario EanX!
                  </span>
                </div>
              </div>
              <div className="row my-4">
                <div className="col-12 landing__paragraph-text">
                  <p className="landing__text-color-dark-green">
                    Queremos que explores nuestra plataforma de cursos digitales de forma gratuita.
                    Para empezar con esta aventura, solo debes ingresar con el correo{' '}
                    <b>demo@eanx.co</b> y la clave <b>Demo1*</b>. Una vez dentro, podrás navegar en
                    algunos de nuestros cursos sin compromiso.
                  </p>

                  <p className="landing__text-color-dark-green">
                    Una vez te decidas, puedes adquirir cualquiera de nuestros planes desde{' '}
                    <b>https://eanx.co/planes.</b>
                  </p>
                  <p className="landing__text-color-dark-green">
                    En EanX, te ofrecemos una experiencia de aprendizaje única, con cursos diseñados
                    por expertos y una plataforma intuitiva y fácil de usar, ¡compruébalo tú
                    mismx!{' '}
                  </p>
                  <p className="landing__text-eres-comunidad-eanista_bold">¡Bienvenidx a EanX!</p>
                </div>
              </div>
            </div>
            <div className="col-lg-7 pe-0 d-none d-lg-grid">
              <div className="justify-content-end " style={{ width: '95%' }}>
                <div className="col-12" style={{ padding: '0px' }}>
                  <iframe
                    className="video-iframe"
                    ref={iframeRef}
                    width="100%"
                    style={{ height: iframeHeight }}
                    src="https://www.youtube.com/embed/4McWM-mF1w8?si=ReyazLDww5QSFHW9&amp;controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SimpleFooter />
    </>
  );
};
